import { applyTilesToFocalPointAspectRatio } from "./applyTilesToFocalPointAspectRatio";

export function calculatePercentNotVisible({
  focalPoint,
  containerWidth,
  containerHeight,
  tiles,
}: {
  focalPoint: FocalPoint;
  containerWidth: number;
  containerHeight: number;
  tiles?: Tiles | undefined;
}) {
  // If we're going to be cropping too much content, we'll force containment.
  const viewportAspectRatio = containerWidth / containerHeight;
  const contentAspectRatio = applyTilesToFocalPointAspectRatio({
    aspectRatio:
      typeof focalPoint.aspectRatio !== "undefined"
        ? focalPoint.aspectRatio
        : (focalPoint.width || 1920) / (focalPoint.height || 1080),
    rows: tiles?.rows ?? 1,
    columns: tiles?.columns ?? 1,
  });

  // Calculate the percentage of the image that will be cropped by _not_
  // containing it
  let percentNotVisible;
  if (viewportAspectRatio < contentAspectRatio) {
    const width = containerHeight * contentAspectRatio;

    // Matching height, expanding the width
    const widthNotVisible = width - containerWidth;
    percentNotVisible = widthNotVisible / width;
  } else {
    const height = containerWidth / contentAspectRatio;
    const heightNotVisible = height - containerHeight;
    percentNotVisible = heightNotVisible / height;
  }

  return percentNotVisible;
}
